export default {
  sizeIdDatabase: "General functions over SizeID database",
  businessAccount: "Functions linked to the SizeID for Business business account",
  sizeIdAccount: "Functions linked to the SizeID user",
  accessTokens: "Authorization tokens"
};
